import { render, staticRenderFns } from "./AccountDisabled.vue?vue&type=template&id=e3627cbe&scoped=true&"
import script from "./AccountDisabled.vue?vue&type=script&lang=ts&"
export * from "./AccountDisabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3627cbe",
  null
  
)

export default component.exports